import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = any[];

export const useDefaultObservableAnyArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectAnyArray extends BehaviorSubject<CurrentType> {}
